document.addEventListener('DOMContentLoaded', function () {
    const workerElements = document.querySelectorAll('.Workers__single');

    workerElements.forEach((worker) => {
        worker.addEventListener('click', function (event) {
            event.preventDefault();

            const hasClickClass = worker.classList.contains('Workers__singleClick');

            if (!hasClickClass) {
                return;
            }
            const shouldRedirect = worker.classList.contains('Workers__singleRedirect');

            if (shouldRedirect) {
                const redirectUrl = worker.getAttribute('data-url');
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
                return;
            }

            const workerId = worker.getAttribute('data-worker-id');
            const blockId = worker.closest('.Workers').id;

            console.log('Worker ID:', workerId);

            if (!workerId) {
                console.error('Worker ID is missing');
                return;
            }

            const popup = document.querySelector(`#WorkersPopup-${blockId}`);
            if (!popup) {
                console.error('Popup not found for block:', blockId);
                return;
            }

            const loader = popup.querySelector('.WorkersPopup__loader');
            const content = popup.querySelector('.WorkersPopup__wrapper');

            loader.style.display = 'block';
            content.style.display = 'none';

            fetch(`/wp-admin/admin-ajax.php?action=get_worker_data&worker_id=${workerId}`)
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        openPopup(popup, data.data);
                    } else {
                        console.error('Error:', data.data);
                    }
                })
                .catch((error) => console.error('Error fetching worker data:', error))
                .finally(() => {
                    loader.style.display = 'none';
                    content.style.display = 'block';
                });
        });
    });

    function openPopup(popup, data) {
        popup.querySelector('.WorkersPopup__title').innerText = data.title;
        popup.querySelector('.WorkersPopup__position').innerText = data.position;
        popup.querySelector('.WorkersPopup__content').innerHTML = data.content;
        popup.querySelector('.WorkersPopup__thumbnail').src = data.thumbnail;
        popup.querySelector('.WorkersPopup__email').innerText = data.email;
        popup.querySelector('.WorkersPopup__email').setAttribute('href', `mailto:${data.email}`);
        if (data.email) {
            popup.querySelector('.WorkersPopup__email').classList.add('visible');
        }
        popup.querySelector('.WorkersPopup__phone').innerText = data.phone;
        popup.querySelector('.WorkersPopup__phone').setAttribute('href', `tel:${data.phone}`);
        if (data.phone) {
            popup.querySelector('.WorkersPopup__phone').classList.add('visible');
        }

        popup.classList.add('active');
        document.body.classList.add('no-scroll'); // Disable page scroll
    }

    function closePopup() {
        const openPopup = document.querySelector('.WorkersPopup.active');
        if (openPopup) {
            openPopup.classList.remove('active');
            document.body.classList.remove('no-scroll'); // Re-enable page scroll
        }
    }

    document.addEventListener('click', function (event) {
        const openPopup = document.querySelector('.WorkersPopup.active');
        if (openPopup && !openPopup.contains(event.target) && event.target !== openPopup) {
            closePopup();
        }
    });

    document.addEventListener('click', function (event) {
        if (event.target.matches('.WorkersPopup__close')) {
            closePopup();
        }
    });
});
